export default
{
  adblock: 'Hello! This site is transparent and lets you chose the 3rd party services you want to allow.',
  adblock_call: 'Please disable your adblocker to start customizing.',
  reload: 'Refresh the page',

  alertDisclaimerTitle: 'Your privacy is our priority',
  alertDisclaimer: 'By continuing your browsing, you agree to the use of cookies by us and our partners to provide content and offers tailored to your interests, personalized advertising and traffic analysis.',
  alertDisclaimerText: '<p>When you visit this site, we and our partners may independently or jointly deposit cookies and similar technologies to collect information, including personal data, such as: IP address, unique identifiers, navigation data, geolocation data. </p><p>This data is processed by us and/or our partners, including advertising partners, for the following purposes: analyzing and improving the user experience, storing and/or accessing information about a terminal, measuring and analyzing the audience, interacting with social networks, fighting fraud, displaying personalized advertisements and content, measuring the performance of advertisements and content.</p><p>Except for those necessary for the operation of the site as well as, under certain conditions, for audience measurement, cookies and similar technologies can only be deposited with your consent. You can freely give, refuse or withdraw your consent at any time by accessing our cookie settings tool. If you do not consent to the use of these technologies, we will consider that you also object to any cookie deposit that some partners justify by a legitimate interest.</p>',
  alertBigScroll: 'By continuing to scroll,',
  alertBigClick: 'If you continue to browse this website,',
  alertBig: 'you are allowing all third-party services',

  alertBigPrivacy: 'This site uses cookies and gives you control over what you want to activate',
  alertSmall: 'Manage services',
  acceptAll: 'OK, accept all',
  personalize: 'Learn more and set up',
  close: '&times;',
  closeTitle: 'Close the window',

  privacyUrl: 'Privacy policy',

  all: 'Preference for all services',

  info: 'Protecting your privacy',
  disclaimer: 'By allowing these third party services, you accept their cookies and the use of tracking technologies necessary for their proper functioning.',
  allow: 'Allow',
  deny: 'Deny',
  noCookie: 'This service does not use cookie.',
  useCookie: 'This service can install',
  useCookieCurrent: 'This service has installed',
  useNoCookie: 'This service has not installed any cookie.',
  more: 'Read more',
  source: 'View the official website',
  credit: 'Cookies manager by Nematis',

  toggleInfoBox: 'Show/hide informations about cookie storage',
  title: 'Managing your cookie preferences',
  cookieDetail: 'Cookie detail for',
  ourSite: 'on our site',
  newWindow: '(new window)',
  accept: 'I accept',
  allowAll: 'Allow all cookies',
  denyAll: 'Deny all cookies',

  fallback: 'is disabled.',

  disabled_content: '%service% is disabled. Allow cookies to be placed to access the content.',
  disabled_video: '%service% is disabled. Allow cookies to be placed to play the video.',

  technical: {
    title: 'Tecnicals cookies',
    details: ''
  },
  ads: {
    title: 'Advertising network',
    details: 'Ad networks can generate revenue by selling advertising space on the site.'
  },
  analytic: {
    title: 'Audience measurement',
    details: 'The audience measurement services used to generate useful statistics attendance to improve the site.'
  },
  social: {
    title: 'Social networks',
    details: 'Social networks can improve the usability of the site and help to promote it via the shares.'
  },
  video: {
    title: 'Videos',
    details: 'Video sharing services help to add rich media on the site and increase its visibility.'
  },
  comment: {
    title: 'Comments',
    details: 'Comments managers facilitate the filing of comments and fight against spam.'
  },
  support: {
    title: 'Support',
    details: 'Support services allow you to get in touch with the site team and help to improve it.'
  },
  api: {
    title: 'APIs',
    details: 'APIs are used to load scripts: geolocation, search engines, translations, ...'
  },
  other: {
    title: 'Other',
    details: 'Services to display web content.'
  }
}
